<template>
	<div class="allchain">
		<leftnav class="fl" mkcode="E" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
                    <filterCom class="mt-3" v-show="navValue == 1"></filterCom>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="pb-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
								<th>序号</th>
                                <th>公司名称</th>
								<th>项目名称</th>
								<th>投资来源地</th>
                                <th>行业</th>
                                <th>产业分类</th>
								<th>投资地点</th>
                                <th>投资金额(万) </th>
                                <th >日期</th>
                                <th >操作</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.region}}</td>
                                <td class="title" @click="handlerLinkLocal('/investDetail?id='+item.id)">{{item.projectname}}</td>
                                <td>{{item.totalarea}}</td>
                                <td>{{item.landuse}}</td>
                                <td class="title" @click="routerlinkid('/enterprises?id='+item.stockcode)">{{item.company}}</td>
                                <td>{{item.source}}</td>
                                <td>{{item.money}}</td>
                                <td>{{item.signDate}}</td>
                                <td class="collectfont1">
                                    <span @click="addClue(item)">加入线索管理</span>
                                </td>
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import filterCom from "./inc/filterCom.vue";
export default {
	name: 'landSearch',
    components: {
        filterCom
    },
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "报告库",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			yj_itemcode: "E02",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
            enterpristlist: [{
                id: 1,
                col:1,
                stockcode: '1',
                region: '秦皇岛海港区盛步储能技术有限公司',
                projectname: '秦皇岛海港区盛步储能技术',
                totalarea: '秦皇岛', 
                landuse: '制造业', 
                company: '秦皇岛海港区盛步储能技术有限公司', 
                investor: '晶科电力有限公司', 
                source: '浙江省嘉兴市', 
                money: '1000',
                signDate: '2025-11-25' 
            }],
            navList: [
                {value:1,label:'投资项目检索'},
                {value:2,label:'投资项目线索管理'},
            ],
            navValue: 1,
		}
	},
	created() {},
	mounted() { },
	methods: {
        addClue(item){ 
        },
        ajaxsearchcompany(page) { 
        },
        pageHandler(page) { 
            this.page = page;
            // this.ajaxsearchcompany(page);
        },
    },
}
</script>

<style lang="scss" >

.collectfont1{
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;
    &:hover{
        color: #f19d00;
    }
}
.land_table{
    margin:  0 auto;
    border: 1px solid #f2f2f2; 
    background: #fff;
    width: 95%;
    .title{
        cursor: pointer;
        color: #305ea3;
        &:hover{
            color: #f19d00;
            text-decoration: underline;
        } 
    }
    th{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    height: 54px;
    line-height: 54px;
    background: #f2f8fe;
    white-space: nowrap;
    padding: 0 10px;
    border-right: 1px solid #dcdcdc;
    }
    tr{
        height: 40px;
        border-bottom: 1px solid #dcdcdc;
        td{
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
        }
    }
}
</style>